export default function StickyResultBar({ label, value, helper, action }) {
  if (!value) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-20 border-t border-brand-border bg-brand-surface/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 rounded-t-2xl px-4 py-3">
        <div className="text-center md:text-left">
          <p className="text-xs uppercase tracking-wide text-brand-muted">{label}</p>
          <p className="text-4xl font-bold leading-none text-brand-accent">{value}</p>
          {helper ? <p className="text-xs text-brand-muted">{helper}</p> : null}
        </div>
        {action ? <div>{action}</div> : null}
      </div>
    </div>
  );
}
